import React, { useState, useEffect, useContext } from "react";
import "./Payments-Table.scss";

//icons import
import { FaPercentage } from "react-icons/fa";
import { MdCreditScore } from "react-icons/md";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { fetchPayments,confirmPayments } from "../../../../redux/slices/sliceActions";

//import context
import { MyContext } from "../../../../tenantsDashContext";
import PaymentConfirmationModal from "./ApprovePaymentModal";

const TransactionsTable = () => {
  //check shared value from context
  const { sharedValue, setSharedValue, rolesAssigned } = useContext(MyContext);

  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [paymentsReceived, setPaymentsReceived] = useState([]);

  useEffect(() => {
    if (property_id) {
      

      dispatch(fetchPayments({ property_id, token })).then((res) => {
        setPaymentsReceived(res.payload.payments);
        console.log("fetching payments", res);
      });
    }
  }, [user]);

  const paymentData = {
    payments: paymentsReceived,
  };

  if (sharedValue === "Invoices") {
    paymentData.payments = paymentsReceived.filter(
      (payment) => payment.payment_status === 0
    );
  }

  const [visiblePayments, setVisiblePayments] = useState(3); // State to manage visible payments
  const [expandedPayment, setExpandedPayment] = useState(null); // State to track which payment is expanded

  // Function to show more payments
  const showMorePayments = () => {
    setVisiblePayments((prev) =>
      Math.min(prev + 3, paymentData.payments.length)
    );
  };

  // Function to hide all payments except the first three
  const hideAllPayments = () => {
    setVisiblePayments(3);
    setExpandedPayment(null); // Collapse any expanded payment
  };

  // Function to handle payment row click
  const handlePaymentClick = (paymentId) => {
    // Toggle expanded state: if it's the same payment, collapse it; otherwise, expand the new one
    setExpandedPayment((prev) => (prev === paymentId ? null : paymentId));
  };

  //approve payment
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => { 
    setIsOpen(false);
  };



  const handleConfrim = () => {
    alert("Payment Approved");
    // const paymentId = parseInt(expandedPayment);
    // dispatch(confirmPayments({ paymentId, token })).then((res) => {
    //   dispatch(
    //     fetchPayments({ property_id, token })
    //   );
    // });

    console.log("cleared");
   
  };

  return (
    <div className="table-container-pc">
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: "start" }}>Payment</th>
            <th>Status</th>
            <th>ID</th>
            <th>Date</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {paymentData.payments
            .slice(0, visiblePayments)
            .map((payment, index) => (
              <React.Fragment key={payment.payment_id || index}>
                <tr
                  onClick={() => handlePaymentClick(payment.payment_id)}
                  className="clickable-row"
                >
                  <td>
                    <i
                      className={`dashboard-icon ${
                        payment.payment_status === 0
                          ? "dashboard-icon-pending"
                          : "dashboard-icon-completed"
                      }`}
                    >
                      {payment.payment_status === 0 ? (
                        <FaPercentage />
                      ) : (
                        <MdCreditScore />
                      )}
                    </i>
                  </td>
                  <td
                    className={`dashboard-status ${
                      payment.payment_status === 0 ? "pending" : "completed"
                    }`}
                  >
                    <div className="status-wrapper">
                      {payment.payment_status === 0 ? "Pending" : "Completed"}
                    </div>
                  </td>
                  <td>{payment.payment_id}</td>
                  <td>{new Date(payment.created_at).toLocaleDateString()}</td>
                  <td>{`ksh ${payment.amount}`}</td>
                </tr>
                {expandedPayment === payment.payment_id && (
                  <tr className="expanded-row">
                    <td colSpan="5">
                      <div className="expanded-content">
                        <div className="title">Transaction Details</div>
                        <div className="data">
                          <div>Invoice ID:</div>
                          <div className="data-details">
                            {payment.invoice.invoice_id}
                          </div>
                        </div>
                        <div className="data">
                          <div>Rent Amount:</div>
                          <div className="data-details">
                            {payment.rent_amount}
                          </div>
                        </div>
                        <div className="data">
                          <div>Arrears Amount:</div>
                          <div className="data-details">
                            {payment.arrears_amount}
                          </div>
                        </div>
                        <div className="data">
                          <div>Garbage Charge:</div>
                          <div className="data-details">
                            {payment.garbage_charge_amount}
                          </div>
                        </div>
                        <div className="data">
                          <div>Water Bill Amount:</div>
                          <div className="data-details">
                            {payment.water_bill_amount}
                          </div>
                        </div>

                        <div className="data">
                          <div>Service Fee Amount:</div>
                          <div className="data-details">
                            {payment.service_fee_amount}
                          </div>
                        </div>

                        <div className="data">
                          <div>Payment ID:</div>
                          <div className="data-details">
                            {payment.payment_id}
                          </div>
                        </div>
                        {payment.payment_status === 0 && (
                          <>
                            <div>
                              {rolesAssigned?.approvePayments && (
                                <>
                                  <button className="approve-payment" onClick={() => {
                                    setIsOpen(true);
                                  }}>
                                    Approve Payment
                                  </button>
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
        </tbody>
      </table>

      {/* Buttons to show more or hide payments */}
      <div className="button-container">
        {visiblePayments < paymentData.payments.length && (
          <button onClick={showMorePayments}>Show More</button>
        )}
        {visiblePayments > 3 && (
          <button onClick={hideAllPayments}>Hide All</button>
        )}
      </div>


      <PaymentConfirmationModal isOpen={isOpen} paymentId={expandedPayment} onConfirm={handleConfrim} onCancel={closeModal} />
    </div>

  );
};

export default TransactionsTable;
